import React from "react";
import classnames from "classnames";

import * as styles from "./MenuItemGroup.scss";

export interface IMenuItemGroupProps {
    className?: string;
    children?: React.ReactNode;
}

export function MenuItemGroup(props: IMenuItemGroupProps) {
    const { className, children } = props;
    return (
        <div className={classnames(styles["menu-item-group"], className)}>
            {children}
        </div>
    );
}
